import { useTranslation } from "react-i18next";

import { DatatableRowData } from "../datatable-types";

import { DatatableColumnToggleRow } from "./datatable-column-toggle-row";
import { useDatatableColumnToggleSectionList } from "./use-datatable-column-toggle-section-list";

export function DatatableDisplayOptionsColumnToggleView<TData extends DatatableRowData>() {
  const { standardColumnList, labelColumnList } = useDatatableColumnToggleSectionList<TData>();
  const { t } = useTranslation("common");

  if (standardColumnList.length === 0 && labelColumnList.length === 0) {
    return null;
  }

  return (
    <>
      <hr />
      <div className="my-2 flex flex-col gap-4">
        <div className="flex flex-row flex-wrap items-center gap-2">
          <div className="py-2 text-xs font-medium text-foreground/80">{t("view.displaySettings")}</div>
          {standardColumnList.length > 0 && <DatatableColumnToggleRow columnList={standardColumnList} />}
          {labelColumnList.length > 0 && (
            <>
              <div className="mb-2 mt-3 w-full text-xs font-medium text-muted-foreground">{t("view.labelColumns")}</div>
              <DatatableColumnToggleRow columnList={labelColumnList} />
            </>
          )}
        </div>
      </div>
    </>
  );
}
